// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"d9f8ff31","286":"d5b3a517","531":"d9f8ff31","754":"639ad465","860":"d9f8ff31"}[chunkId] + ".chunk.css";
};